import { useEffect } from "react";
import "./ScamSlam.css"

export default function ScamSlam() {
//  useEffect(() => {
//    // Prevent multiple loads using a global flag
//    if (!window.p5Loaded) {
//      window.p5Loaded = true; // Set flag to true
//
//      const scriptP5 = document.createElement("script");
//      scriptP5.src = "https://cdn.jsdelivr.net/npm/p5@1.2.0/lib/p5.js";
//      scriptP5.async = true;
//      document.body.appendChild(scriptP5);
//    }
//
//    if (!window.scamSlamLoaded) {
//      window.scamSlamLoaded = true;
//
//      const scriptSketch = document.createElement("script");
//      scriptSketch.src = "/p5js/ScamSlamGame/scripts/sketch.js";
//      scriptSketch.defer = true;
//      document.body.appendChild(scriptSketch);
//
//      const scriptLevel = document.createElement("script");
//      scriptLevel.src = "/p5js/ScamSlamGame/scripts/level_select.js";
//      scriptLevel.defer = true;
//      document.body.appendChild(scriptLevel);
//    }
//
//    return () => {
//      console.log("Scam Slam component unmounted.");
//    };
//  }, []);


  return (
    <div className="ScamSlam">
//      <h1>Scam Slam (Freshman Launchpad Project)</h1>
//      <div className="contentContainer">
//        <div></div>
//        <div className="leftText">
//          <h4>Controls:</h4>
//          Movement: Arrows<br />
//          Shoot: Space<br />
//          Pause: Escape<br /><br/>
//          Please note this game is not mobile compatible
//        </div>
//        <figure style={{height: "330px", width: "572px", margin:"auto"}} id="sketchContainer"></figure>
//        <div className="rightText">
//          <h4>About the Author:</h4>
//          As of now, Steven
//          Schonlau is a freshman
//          CS major at Purdue.
//          He created this game
//          with p5.js, HTML, and
//          CSS. The intent of
//          this game is to
//          educate everyone
//          about email scams.
//        </div>
//        <div></div>
//      </div>
    </div>
  );
}
